import { AppStorage } from './app.storage'

class LocaleStorage extends AppStorage{
  constructor ( key, isSession ) {
    super( key, isSession )

    const defaultObjct = {
      defaultLang: null,
      langs: []
    }

    const alreadHas = JSON.parse( this.getValue() )
    if( !alreadHas ) {
      this.setValue( JSON.stringify( defaultObjct ) )
    }
  }

  getDefaultLanguage () {
    const data = JSON.parse( this.getValue() )
    return data.defaultLang || null
  }

  getLanguageLoaded ( code ) {
    const languages = JSON.parse( this.getValue() )
    const findLan = languages.langs.filter( i => i.code === code )[0]
    return findLan || null
  }

  addLanguageLoaded ( data ) {
    const languages = JSON.parse( this.getValue() )
    const has = languages.langs.filter( i => i.code === data.code )[0]
    languages.defaultLang = data

    if( !has ) {
      languages.langs.push( data )
      this.setValue( JSON.stringify( languages ) )
    } else {
      this.setValue( JSON.stringify( languages ) )
    }
  }
}
export default new LocaleStorage( '__language__' )


// WEBPACK FOOTER //
// ./src/storage/locale.storage.js